import { getFacilitiesTemplate } from "@/api/template";
import ActionsPopOverItem from "@/components/ActionsPopOver/ActionsPopOverItem";
import FileUploader from "@/components/FileUploader/FileUploader";
import FacilitiesIcon from "@/components/icons/chapters/FacilitiesIcon";
import { FacilitiesHowItWorks } from "./FacilitiesHowItWorks";

export default function UploadFacilitiesButton() {
  return (
    <FileUploader
      buttonType="primary"
      uploadType={"location"}
      buttonText={"Upload"}
      howItWorks={<FacilitiesHowItWorks />}
      templateUrlFn={getFacilitiesTemplate}
      uploadDataTableProps={{
        rowKey: "key",
        columns: [
          {
            label: "Facility name",
            key: "facility_name",
          },
          {
            label: "Address",
            key: "address",
          },
          {
            label: "Category",
            key: "category",
          },
          {
            label: "Type",
            key: "type",
          },
          {
            label: "Published",
            key: "published",
          },
        ],
      }}
      customRender={(props) => (
        <ActionsPopOverItem
          icon={<FacilitiesIcon />}
          black
          {...props}
        >
          Facilities
        </ActionsPopOverItem>
      )}
    />
  );
}
